import api from './api';

export const vendorService = {
  getAll: () => api.get('/vendors/'),
  create: (vendor) => api.post('/vendors/', vendor),
  getById: (id) => api.get(`/vendors/${id}`),
  update: (id, vendor) => api.put(`/vendors/${id}`, vendor),
  delete: (id) => api.delete(`/vendors/${id}`)
};
